var _a;
export var mobile = function (breakpoint) { return "only screen and (max-width: ".concat(breakpoint - 1, "px)"); };
export var loader = {
    alignItems: 'center',
    background: 'rgba(245, 245, 245, 0.5)',
    color: '#666666',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
    zIndex: 799,
};
export var transparentBg = {
    background: 'unset',
};
export var bodyLoader = {
    background: 'rgba(0, 0, 0, 0.5)',
    bottom: 0,
    color: '#fff',
    height: '100%',
    left: 0,
    overflow: 'hidden',
    position: 'fixed',
    right: 0,
    top: 0,
    width: '100%',
    zIndex: 1000,
};
export var wrapper = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
};
export var message = (_a = {
        fontSize: 26,
        fontWeight: '300',
        lineHeight: 32 + 'px',
        marginTop: 24,
        maxWidth: 600,
        textAlign: 'center',
        width: '80%'
    },
    _a["@media ".concat(mobile(700))] = {
        fontSize: 18,
        lineHeight: 24 + 'px',
    },
    _a);
export var loadingAnimation = {
    whiteSpace: 'nowrap',
    '@keyframes bouncedelay': {
        '0%': {
            transform: 'scale(0)',
        },
        '80%': {
            transform: 'scale(0)',
        },
        '100%': {
            transform: 'scale(0)',
        },
        '40%': {
            transform: 'scale(1)',
        },
    },
};
export var loaderDot = {
    verticalAlign: 'middle',
    width: 12,
    height: 12,
    backgroundColor: '#41a8d2',
    borderRadius: '100%',
    display: 'inline-block',
    animation: "bouncedelay ".concat(parseFloat('300ms'.replace('ms', '')) * 4, "ms infinite ease-in-out"),
    /* Prevent first frame from flickering when animation starts */
    animationFillMode: 'both',
    '@media screen and (prefers-reduced-motion: reduce)': {
        animationDuration: '2s',
    },
};
export var loaderDotBody = {
    width: 24,
    height: 24,
    backgroundColor: '#ffffff',
};
export var loaderDot1 = {
    animationDelay: "-".concat('300ms'),
};
export var loaderDot2 = {
    animationDelay: "-".concat(parseFloat('300ms'.replace('ms', '')) / 2, "ms"),
};
export var hiddenText = {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px',
};
